import { Routes, Route, Outlet } from "react-router";
import { StatisticsByRoutePairDetailsScreen } from "./pages/route/StatisticsByRoutePairDetailsScreen";
import { StatisticsBySalesRegionDetailsScreen } from "./pages/sales-region/StatisticsBySalesRegionDetailsScreen";
import { StatisticsBySellerDetailsScreen } from "./pages/seller/StatisticsBySellerDetailsScreen";
import { SearchFilterSelectorProvider } from "@/features/search-filter/context/searchFilterSelectorContext";
import {
  createFppSearchFilterActions,
  initialSearchFilterFormModel,
} from "@/features/search-filter/redux/reducer";
import {
  SearchFilterContext,
  createSearchFilterInitialState,
} from "@stenajs-webui/filter";
import { useDispatch } from "react-redux";
import { StatisticsProvider } from "./StatisticsContext";
import { StatisticsByCustomerDetailsScreen } from "./pages/customer/StatisticsByCustomerDetailsScreen";
import { StatisticsTabRoutes } from "./StatisticsTabRouter";

export const Layout = () => {
  const dispatch = useDispatch();

  return (
    <StatisticsProvider>
      <SearchFilterSelectorProvider
        reducerId={"statistics.statisticsByCustomer"}
      >
        <SearchFilterContext
          state={createSearchFilterInitialState(initialSearchFilterFormModel)}
          actions={createFppSearchFilterActions(
            "statistics.statisticsByCustomer"
          )}
          dispatch={dispatch}
        >
          <Outlet />
        </SearchFilterContext>
      </SearchFilterSelectorProvider>
    </StatisticsProvider>
  );
};

export const StatisticsRouter = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path={"/*"} element={<StatisticsTabRoutes />} />
        <Route
          path={"seller/:sellerId"}
          element={<StatisticsBySellerDetailsScreen />}
        />
        <Route
          path={"route/:routeId"}
          element={<StatisticsByRoutePairDetailsScreen />}
        />
        <Route
          path={"/sales-region/:salesRegionId"}
          element={<StatisticsBySalesRegionDetailsScreen />}
        />
        <Route
          path={"/customer/:customerId"}
          element={<StatisticsByCustomerDetailsScreen />}
        />
      </Route>
    </Routes>
  );
};
